import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from '@tcc/i18n';
import styles from '../cardAndPreview/cardAndPreview.css';
import PreviewNavigationCard from '../cardAndPreview/PreviewNavigationCard';

function SoilSsurgoPreview({
  activeZone,
  decrementZoneIndex,
  incrementZoneIndex,
  isLoading,
}) {
  const zone = activeZone || {};
  return (
    <PreviewNavigationCard
      errorMessage={activeZone === null ? getMessage('noDataError') : ''}
      isLoading={isLoading}
      onLeftClick={decrementZoneIndex}
      onRightClick={incrementZoneIndex}
      testId="dmb-soil-ssurgo"
    >
      <div className={styles.column}>
        <div
          className={styles.value}
          data-test-id="soil-ssurgo-preview-soil-type-value"
        >
          {zone.soilTypeAbbreviated}
        </div>
        <h3 data-test-id="soil-ssurgo-preview-drainage-value">
          {zone.drainage}
        </h3>
      </div>
    </PreviewNavigationCard>
  );
}

SoilSsurgoPreview.propTypes = {
  activeZone: PropTypes.object,
  decrementZoneIndex: PropTypes.func.isRequired,
  incrementZoneIndex: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default SoilSsurgoPreview;
